<div class="main-container lg-view" *ngIf="!isLoading">
	<h3>Add Documents</h3>

	<div class="main-form">
		<form [formGroup]="formModel">
			<fieldset>
				<legend>{{ job.jobName }}</legend>

				<div class="form-button-container">
					<button mat-raised-button type="button" (click)="openMyCloud()">My Cloud</button>
					<button mat-raised-button type="button" (click)="fileUpload.click()">
						Select Document </button>
					<!-- <button mat-raised-button class="secondary" type="button" (click)="clearFilesList()"
						*ngIf="filesToUpload?.length" @fadeIn @fadeOut>Clear</button> -->
				</div>

				<mat-form-field>
					<mat-label>Type</mat-label>
					<mat-select formControlName="documentTypeMappingId" (selectionChange)="onTypeChanged($event)">
						<mat-option *ngFor="let type of documentTypeOptions" [value]="type.id">
							{{type.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field>
					<mat-label>Name</mat-label>
					<input matInput formControlName="description" />
				</mat-form-field>

				<mat-form-field class="calendar">
					<mat-label>Effective Date</mat-label>
					<input matInput [matDatepicker]="effectiveDatePicker" formControlName="effectiveDate">
					<mat-datepicker-toggle matSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #effectiveDatePicker></mat-datepicker>
					<mat-icon class="clear-button" (click)="clearEffectiveDate($event)">clear
					</mat-icon>
				</mat-form-field>

				<mat-form-field *ngIf="jobDocumentationAssetTypes?.length > 0">
					<mat-label>Asset Types</mat-label>
					<mat-select formControlName="documentationAssetTypes" multiple>
						<mat-option *ngFor="let assetType of jobDocumentationAssetTypes" [value]="assetType.id">
							{{assetType.name}}</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field *ngIf="descriptiveTags?.length > 0">
					<mat-label>Descriptive Tag</mat-label>
					<mat-select formControlName="descriptiveTagId">
						<mat-option [value]="null">None</mat-option>
						<mat-option *ngFor="let tag of descriptiveTags" [value]="tag.id">
							{{tag.name}}</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field *ngIf="calendarBasedTags?.length > 0">
					<mat-label>Calendar Tags</mat-label>
					<mat-select formControlName="calendarBasedTagIds" multiple>
						<mat-option *ngFor="let option of calendarBasedTags" [value]="option.id">
							{{option.name}}</mat-option>
					</mat-select>
				</mat-form-field>

				<div class="files-list-container" *ngIf="filesToUpload?.length">
					<div class="file" *ngFor="let file of filesToUpload; let index = index">
						<span>{{ file.name }}</span>
						<button mat-flat-button (click)="removeUploadSelection(index)">
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>

				<div class="files-list-container" *ngIf="myCloudSelectedFiles?.length">
					<div class="file" *ngFor="let file of myCloudSelectedFiles; let index = index">
						<span>{{ file.documentName }}</span>
						<button mat-flat-button (click)="removeMyCloudSelection(index)">
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
			</fieldset>

			<fieldset *ngIf="massCompletionAdditionalAssets" class="list">
				<legend>Additional {{massCompletionAdditionalAssets.assetType}}</legend>

				<ul>
					<li *ngFor="let asset of massCompletionAdditionalAssets.assets">
						<mat-checkbox [disabled]="isLoading" (change)="onOtherAssetChange($event, asset.assetId)">
							{{asset.assetName}}</mat-checkbox>
					</li>
				</ul>
			</fieldset>
		</form>
	</div>
</div>

<div class="actions-container md-view" *ngIf="!isLoading">
	<ng-container *ngIf="isActionAvailable">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
		<action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitDocuments.bind(self)"
			[disabled]="formModel.invalid || (!filesToUpload?.length && !myCloudSelectedFiles?.length)"></action-button>
	</ng-container>

	<div class="actions-placeholder-message"
		*ngIf="pageType === PageType.Customer && (customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>

	<div class="actions-placeholder-message"
		*ngIf="BitwiseHelper.and(pageType, PageType.AssigneeOrVendor) && customerPreferences.preferences.isJobAutoSkipped">
		<span *ngIf="customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
	</div>
</div>

<input type="file" #fileUpload (change)="chooseFiles($event.target.files)" name="fileUpload" style="display:none;" />

<generic-modal #emptyDocumentModal>
	<ng-template #modalBody>
		The uploaded document cannot be empty!
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="emptyDocumentModal.hide()">Ok</button>
	</ng-template>
</generic-modal>